import React, { useState } from 'react'
import styled from 'styled-components'
import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded'
import KpiReportDialog from 'features/dashboard/sections/KpiReportDialog'

const KpiReportButton = ({ initial, title = 'Download a KPI report with the sites and dates shown here' }) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Btn type='button' onClick={() => setOpen(true)} title={title}>
        <AssessmentRoundedIcon style={{ fontSize: 16 }} />
        <span>Download KPI report</span>
      </Btn>
      <KpiReportDialog open={open} onClose={() => setOpen(false)} initial={initial} />
    </>
  )
}

export default KpiReportButton

const Btn = styled.button`
  font: inherit; display: inline-flex; align-items: center; gap: 6px;
  min-height: 40px; padding: 8px 14px; border-radius: 10px; cursor: pointer;
  background: ${({ theme }) => theme?.colors?.secondary || '#33becc'}; border: 1px solid ${({ theme }) => theme?.colors?.secondary || '#33becc'};
  color: #fff; font-weight: 700; font-size: 13px;
  &:hover:not(:disabled) { filter: brightness(1.05); }
  &:disabled { opacity: 0.6; cursor: default; }
`
